const React = require('react');
const Switch = require('@material-ui/core/Switch').default;
const CheckboxB = require('../Checkbox/B');


module.exports = (props) => {
  const {
    label,
    onChange,
    checked,
  } = props;
  const disabled = props.disabled || false;

  return (
    <div className={'layoutRow fhaS fvaC mh-5 ' + (props.className || '')}>
      <div className="layoutRow fhaS fvaC">
        <CheckboxB
          className="c575960 mr10"
          checked={checked}
          disabled={disabled}
        />
        <Switch
          {...props}
          color="default"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange && onChange(e.target.checked)}
        />
      </div>
      {
        label ? (
          <div
            className="ml15 f15 lh160% ff$2 usN cr@mouse"
            onClick={() => {
              !disabled && onChange && onChange(!checked);
            }}
          >{label}</div>
        ) : null
      }
    </div>
  );
};
